import { Box, BoxProps } from '@mui/material';

type IHeaderSpacerProps = BoxProps;

function HeaderSpacer(props: IHeaderSpacerProps) {
  return <Box {...props} flex={1} />;
}

export { HeaderSpacer };
